module.exports = __webpack_public_path__ + "img/pin-01.65742aa1.svg";